module.exports = __webpack_public_path__ + "static/media/Envios_Lotes.8dbc869e.xlsm";